<template>
  <v-container
    style="width: 100%;"
    fluid>
    <v-row>
      <v-col
        cols="12">
        <ReportFilter
          ref="ReportFilter"
          @handlerClickFilter="handlerClickFilter"
          @clearFilters="clearFilters"
          :resetFilterMyReports="resetFilterMyReports"
          @hasFiltersMyReports="hasFiltersMyReports"
          @updateDates="updateDates"
        />
      </v-col>

      <v-col
        cols="12"
        class="pa-0">
        <ReportTable
          ref="MyReportsTable"
          :filter="filterMyReports"
        />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import MovementRecordsMixin from '@/shared/mixins/movementRecords/movementRecordsMixin';
import ReportFilter from '@/components/Invoicing/components/report/ReportFilter.vue';
import ReportTable from '@/components/Invoicing/components/report/ReportTable.vue';
import InvoicingMixin from '@/shared/mixins/invoicing/invoicingMixin';
import { cloneDeep } from 'lodash';
import { mapGetters } from 'vuex';
import moment from 'moment';

export default {
  name: "InvoicingReport",

  components: {
    ReportFilter,
    ReportTable,
  },

  data: () => ({
    resetFilterMyReports: false,
    filterForCheckMyReports: {},
    financialGroups: [],
    dates: [],
  }),

  mixins: [
    MovementRecordsMixin,
    InvoicingMixin,
  ],

  props: {
    tab: {
      type: String,
    }
  },

  watch: {
    tab: {
      handler(tabValue) {
        if (tabValue === 'reports') {
          const reportFilterRef = this.$refs.ReportFilter;

          if (reportFilterRef) reportFilterRef.handlerFilter();
        }
      },
    }
  },

  methods: {
    handlerClickFilter(dates) {
      if (dates && dates.length > 0) {
        this.processDates(dates);

        const commonFilterProperties = {
          receivingDateStart: this.dates[0],
          receivingDateEnd: this.dates[1],
        };

        this.handleMyReports(commonFilterProperties);
      } else {
        this.dates = [];
      }
    },

    updateDates(dates) {
      this.processDates(dates);

      this.filterMyReports = {
        ...this.filterMyReports,
        receivingDateStart: this.dates[0],
        receivingDateEnd: this.dates[1],
      }

      this.dataFilterMyReports = cloneDeep(this.filterMyReports);
    },

    processDates(dates) {
      const startDate = moment(dates[0]);
      const endDate = moment(dates[1]);

      this.dates[0] = this.setDateTimezone(startDate.startOf('day'))
      this.dates[1] = this.setDateTimezone(endDate.endOf('day').add(3, 'hours'))

      this.dates[0] = this.formatDate(this.dates[0])
      this.dates[1] = this.formatDate(this.dates[1])
    },

    setDateTimezone(date) {
      return date.add(3, 'hours')
    },

    formatDate(date) {
      return date.format('YYYY-MM-DDTHH:mm:ss.SSS');
    },

    clearFilters() {
      this.resetFilterMyReports = true;
    },

    handleMyReports(commonFilterProperties) {
      this.resetFilterMyReports = false;

      this.filterMyReports = {
        ...this.dataFilterMyReports,
        ...commonFilterProperties,
      }

      setTimeout(() => {
        this.$refs.MyReportsTable.handlerFilter(this.filterMyReports, 'click');
      }, 200);
    },

    hasFiltersMyReports(data) {
      this.dataFilterMyReports = cloneDeep(data);

      this.filterMyReports = {
        ...this.filterMyReports,
        ...this.dataFilterMyReports
      }
    },
  },

  computed: {
    ...mapGetters({
      isRHProtegido: 'user-info/isRHProtegido',
    }),
  },
}
</script>